import styled from 'styled-components';


const FixPosition = styled.div<{ positionLock?: boolean }>`
      position: ${({ positionLock }) => (positionLock ? 'relative' : 'static')};
      width: 100%;
`;

export default { FixPosition };
